import React,{useEffect,useState} from 'react';
import { Link } from 'react-router-dom';
import './styles/App.css';
import Callimg from './img/fluent_call-20-regular.png';
import Ximg from './img/bi_x.png';
import M_Footer from './M_Footer';
import axios from 'axios';
import KakaoMap from './KakaoMap';
import queryString from 'query-string';
import { Row } from 'react-bootstrap';
import { instance } from './common';

import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption
} from 'reactstrap';

const MainS = (props) => {

let items = JSON.parse(props.si_img).map(v => ({src:v}));



const [activeIndex, setActiveIndex] = useState(0);
const [animating, setAnimating] = useState(false);

const next = () => {
  if (animating) return;
  const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
  setActiveIndex(nextIndex);
}

const previous = () => {
  if (animating) return;
  const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
  setActiveIndex(nextIndex);
}

const goToIndex = (newIndex) => {
  if (animating) return;
  setActiveIndex(newIndex);
}


const slides = items.map((item) => {
  return (
    <CarouselItem
      onExiting={() => setAnimating(true)}
      onExited={() => setAnimating(false)}
      key={item.src}
    >
      <img src={item.src} alt={item.altText} />
      <CarouselCaption captionText={item.caption} captionHeader={item.caption} />
    </CarouselItem>
  );
});



return (
  <Carousel
    activeIndex={activeIndex}
    next={next}
    previous={previous}
  >
    <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
    {slides}
    <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
    <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
  </Carousel>
);
}


function RepStoreInfo({ location, match, history }) {
  const query = queryString.parse(location.search);
  const si_id = query.si_id;

  const [data, setData] = useState([]);
  let obj = {si_id:si_id}

  useEffect(() => {
      
      const fetchData = async () => {
        instance.post('/sigong/id',obj).then(function(res){
              
              setData(res.data[0]);
              loadService(si_tel);
          });
      
      };

      fetchData();

  }, []);

  const goBack = () => {
    history.push('/repFindShop');
  };

  console.log('data  : ', data)
  const {si_area1,si_area2,si_name,si_address,si_tel,si_possible,si_rest,	si_dongsi,si_img} = data;
  console.log('si_area1 : ', si_area1)

  
  return (
    <>
    
      <div className="container mb-5">
        <div className="row">
          <h3 className="col-12 text-center font-weight-bold mb-4 mt-4">대리점 상세보기</h3>
          {
            si_img
            ?
            <MainS si_img={si_img} />
            :<div className="col-12 st_img"></div>
          }
          <div className="col-12 mt-3 px-0">
            <div>
              <div>
                <span className="font-weight-bold ph_name px-0 d-inline-block w-75" id="sigong-name">{si_name}</span>
                <span className="btn btn-primary btn-sm p rounded-pill mt-1 ph_btn imo_ph_img" id="telBtn">
                    
                </span><br></br>
              </div>
              <div>
                <span className="detail-name d-block" id="sigong-addr">{si_address}</span>
                <span className="detail-name" id="sigong-tel">{si_tel}</span>
              </div>
              <div>
                <span className="detail-name font-weight-bold" id="">실내시공 가능여부 : </span>
                <span className="detail-name font-weight-bold" id="">{si_possible}</span>
              </div>
              <div>
                <span className="detail-name font-weight-bold" id="">휴게실 유무 : </span>
                <span className="detail-name font-weight-bold" id="">{si_rest}</span>
              </div>
              <div>
                <span className="detail-name font-weight-bold" id="">차량 동시 시공 대수 : </span>
                <span className="detail-name font-weight-bold" id="">{si_dongsi}</span>
              </div>
            </div>

            <div className="text-center ph_map mt-5">
              <KakaoMap si_id={si_id}/>
            </div>
            <div>
              <span className="btn btn-primary r_btnsize mt-5" onClick={() => history.push('/repCalendar?si_id='+si_id)}>시공점 선택</span>
              <span className="btn btn-primary r_btnsize mt-3" onClick={goBack}>뒤로가기</span>
            </div>
          </div>
        </div>
      </div>
       
    </>
    
  );
}

function loadService(si_tel) {
  let str = '';
  if(si_tel){
    str = ' <a href="tel:' + si_tel + '" class="text-white"><img class="" src="' + Callimg + '"> 전화</a>';
  }else{
    str = ' <a href="" class="text-white"><img class="" src="' + Callimg + '"> 전화</a>';
  }
  //let str = '<a href="tel:'+si_tel+'" class="text-white"><img class="imo_ph_img" src=\''+Callimg+'\' />전화</a>';
  
  document.getElementById('telBtn').innerHTML = str;
}
  


export default RepStoreInfo;